"use client";

import { useState, useCallback } from "react";
import VirtuosoMainCard from "@/components/virtuosomaincard/VirtuosoMainCard";
import { PersonContent, PersonMeta } from "@/types/person";
import { getPersonById } from "@/services/person";
interface Props {
  title: string;
  personUuid: string;
  movies: PersonContent[];
  meta?: PersonMeta;
}
export default function CrewRelatedMovies({
  title,
  personUuid,
  movies,
  meta
}: Props) {
  const [items, setItems] = useState<PersonContent[]>(movies);
  const [currentMeta, setCurrentMeta] = useState<PersonMeta | undefined>(meta);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const hasMore = Boolean(currentMeta?.next_page);
  const handleLoadMore = useCallback(async () => {
    if (!hasMore || isLoadingMore || !currentMeta?.next_page) return;
    setIsLoadingMore(true);
    try {
      const res = await getPersonById(personUuid, {
        page: currentMeta.next_page,
        limit: currentMeta.limit ?? 20
      });
      if (res.data?.contents) {
        setItems(prev => [...prev, ...res.data.contents]);
        setCurrentMeta(res.data.meta);
      }
    } finally {
      setIsLoadingMore(false);
    }
  }, [hasMore, isLoadingMore, currentMeta, personUuid]);
  if (!items?.length) return null;
  return <section className="mt-10 pb-8 lg:pb-0">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-base md:text-lg font-bold text-foreground">{title}</h2>
      </div>
      <VirtuosoMainCard data={items} hasMore={hasMore} isLoadingMore={isLoadingMore} onLoadMore={handleLoadMore} />
    </section>;
}